/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface AdminSimpleUserResponse {
  /** The actual database ID for the user */
  id: number;
  /** The public ID, which is used for normal users and routing */
  publicId: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  discriminator: number | null;
  /** This is the name of the role for easy display */
  role: string;
  gender: string;
  isApproved: boolean;
  isActive: boolean;
  proficiencyCount: number;
}
const AdminSimpleUserResponse = {
  create: (initValues?: Partial<AdminSimpleUserResponse> | null): AdminSimpleUserResponse => {
    const defaults: AdminSimpleUserResponse = {
      id: 0,
      publicId: "",
      emailAddress: "",
      firstName: "",
      lastName: "",
      discriminator: null,
      role: "",
      gender: "",
      isApproved: false,
      isActive: false,
      proficiencyCount: 0,
    };
    const fixedValues: Partial<AdminSimpleUserResponse> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default AdminSimpleUserResponse;
